import { ReportEvaluateDTO } from '../../../src_server/entity/dto/ReportEvaluateDTO';


import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class DailyReportService extends GeneratedBizBase{
  async getTeachersReportAnalitics(firstDate: string,endDate: string,building_id: string): Promise<Response<ReportEvaluateDTO[]>> {
    return super.restCall<Response<ReportEvaluateDTO[]>>('get', '/v1/DailyReportService/getTeachersReportAnalitics', arguments);
  }
  async saveEvaluation(class_id: number,evaluation: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/DailyReportService/saveEvaluation', arguments);
  }
  async saveAndSendNotify(dto: ReportDTO,building: string): Promise<Response<ReportDTO>> {
    return super.restCall<Response<ReportDTO>>('post', '/v1/DailyReportService/saveAndSendNotify', arguments);
  }
  async saveTemporary(dto: ReportDTO,building: string): Promise<Response<ReportDTO>> {
    return super.restCall<Response<ReportDTO>>('post', '/v1/DailyReportService/saveTemporary', arguments);
  }
  async getReportForInput(class_id: number,edit_user_id: string): Promise<Response<ReportDTO>> {
    return super.restCall<Response<ReportDTO>>('get', '/v1/DailyReportService/getReportForInput', arguments);
  }
  async addComment(class_id: number,from_user_id: string,to_user_id: string,commentString: string,lessonDate: Date,fileNames: string[],building: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/DailyReportService/addComment', arguments);
  }
  async getTeacherReportList(teacher_user_id: string): Promise<Response<ReportDTO[]>> {
    return super.restCall<Response<ReportDTO[]>>('get', '/v1/DailyReportService/getTeacherReportList', arguments);
  }
  async deleteComment(report_comment_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/DailyReportService/deleteComment', arguments);
  }
}
